import lazyLoading from './lazyLoading'

export default {
  name: 'Forms',
  meta: {
    expanded: false,
    title: 'menu.inventary.parent',
    iconClass: 'vuestic-icon vuestic-icon-extras'
  },
  children: [
    {
      name: 'InventaryList',
      path: '/inventary/list',
      component: lazyLoading('inventary/List'),
      meta: {
        title: 'menu.inventary.list'
      }
    },
    {
      name: 'InventaryReview',
      path: '/inventary/review/:id',
      component: lazyLoading('inventary/Form'),
      meta: {
        title: 'menu.inventary.review'
      },
      hidden: true
    }
  ]
}




// WEBPACK FOOTER //
// ./src/store/modules/menu/inventary.js